import { gql } from '@apollo/client';

export const GET_SUBSIDY_CONTEXT = gql`
  query GetSubsidyContext($input: SubsidyContextInput!) {
    subsidyContext(input: $input) {
      dealerParticipationPercentage
    }
  }
`;
